import request from '../../request';
import { constructUrlObject } from '../../../utils/shared/urlUtils';
import { PARAM } from '../../../constants/shared/ApiConstants';

const { STAFF_UID, INST_UID, CLASS_OR_GROUP_ID, GRADE_LEVEL, PERIOD } = PARAM;

class SharedInstructionClient {
    static getCheckPoints = (staffId, school, classe, url) =>
        request.get(
            constructUrlObject(url, {
                [STAFF_UID]: staffId,
                [INST_UID]: school,
                [CLASS_OR_GROUP_ID]: classe,
            }),
        );

    static saveCheckPoint = (staffId, school, classe, grade, period, url) =>
        request.post(url, {
            [STAFF_UID]: staffId,
            [INST_UID]: school,
            [CLASS_OR_GROUP_ID]: classe,
            [GRADE_LEVEL]: grade,
            [PERIOD]: period,
        });
}

export default SharedInstructionClient;
